import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, TrendingDown, ChevronRight, Film } from 'lucide-react';
import { Button } from './ui/button';

const HotProperties = ({ stocks = [], title = "Hot MovieStocks", loading = false }) => {
  if (loading) {
    return (
      <section className="py-12 px-4" data-testid="hot-properties-section">
        <div className="max-w-7xl mx-auto">
          <div className="h-8 bg-[#1E293B] rounded w-48 mb-6 animate-pulse" />
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            {[1,2,3,4].map(i => <div key={i} className="h-40 bg-[#121826] rounded-2xl border border-[#1E293B] animate-pulse" />)}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 px-4" data-testid="hot-properties-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#F59E0B]/20 rounded-xl flex items-center justify-center">
              <Film className="w-5 h-5 text-[#F59E0B]" />
            </div>
            <div>
              <h2 className="text-[#F8FAFC] font-bold text-xl font-heading">{title}</h2>
              <p className="text-[#64748B] text-sm">Most actively traded securities</p>
            </div>
          </div>
          <Link to="/securities">
            <Button variant="ghost" className="text-[#F59E0B] hover:text-[#D97706] hover:bg-[#F59E0B]/10">
              View All <ChevronRight className="w-4 h-4 ml-1" />
            </Button>
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {stocks.slice(0, 8).map((s) => {
            const isUp = (s.change_percent || s.change || 0) >= 0;
            const imgUrl = s.poster_url || s.photo_url;
            return (
              <Link key={s.id || s.symbol} to={`/security/${s.symbol}`}
                className="bg-[#121826] rounded-2xl border border-[#1E293B] p-4 hover:border-[#F59E0B]/50 hover:shadow-[0_0_20px_rgba(245,158,11,0.1)] transition-all duration-300 group"
                data-testid={`hot-stock-${s.symbol}`}
              >
                <div className="flex gap-4">
                  <div className="w-16 h-22 bg-[#1E293B] rounded-xl overflow-hidden flex-shrink-0 flex items-center justify-center">
                    {imgUrl ? (
                      <img src={imgUrl} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                    ) : (
                      <span className="text-xl font-black text-[#F59E0B]/40 font-mono">{s.symbol?.slice(0, 2)}</span>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2 mb-1">
                      <h4 className="text-[#F8FAFC] font-semibold text-sm truncate group-hover:text-[#F59E0B] transition-colors">{s.name}</h4>
                    </div>
                    <span className="text-[#F59E0B] font-mono text-xs bg-[#F59E0B]/10 px-2 py-0.5 rounded inline-block mb-2">{s.symbol}</span>
                    <div className="flex items-baseline gap-2">
                      <span className="text-[#F8FAFC] font-bold text-lg font-mono">B₹{(s.price || 0).toFixed(2)}</span>
                    </div>
                    <span className={`text-sm font-mono font-medium flex items-center gap-1 mt-1 ${isUp ? 'text-[#10B981]' : 'text-[#EF4444]'}`}>
                      {isUp ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                      {isUp ? '+' : ''}{(s.change_percent || 0).toFixed(2)}%
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HotProperties;
